module.exports = __webpack_public_path__ + "aff3cba2c79d30e428bd28917e6580c0.MP3";